import React from "react";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import { AsyncPaginate } from "react-select-async-paginate";
import usePhotoUploadWorkModal from "./useBarcodeWorkModal";

function PhotoUploadWorkModal({ handleClose, refetch, state }) {
  const {
    formik,
    loadEmployeeOptions,
    loadCertificateOptions,
    selectAll,
    handleSelectAll,
    handleCertificateChange,
  } = usePhotoUploadWorkModal({
    handleClose,
    refetch,
    state,
  });

  return (
    <>
      <div className="input-wrap pro-mb-4">
        <div className="pro-d-flex pro-mb-3 pro-w-100 pro-gap-2">
          <div className="input-wrap pro-mb-3 pro-w-50">
            <label
              htmlFor="start_time"
              className="pro-font-sm pro-mb-1 pro-fw-medium"
            >
              Start Time
            </label>
            <div className="pro-d-flex pro-gap-2 pro-w-100 pro-flex-wrap">
              <input
                id="start_time"
                name="start_time"
                type="time"
                className={`pro-input lg ${
                  formik.errors.start_time &&
                  formik.touched.start_time &&
                  "error"
                }`}
                style={{ flex: 1 }}
                value={formik.values.start_time}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.start_time && formik.errors.start_time && (
                <span className="error-text">{formik.errors.start_time}</span>
              )}
            </div>
          </div>

          <div className="input-wrap pro-mb-3 pro-w-50">
            <label
              htmlFor="end_time"
              className="pro-font-sm pro-mb-1 pro-fw-medium"
            >
              End Time
            </label>
            <div className="pro-d-flex pro-gap-2 pro-w-100 pro-flex-wrap">
              <input
                id="end_time"
                name="end_time"
                type="time"
                className={`pro-input lg ${
                  formik.errors.end_time && formik.touched.end_time && "error"
                }`}
                style={{ flex: 1 }}
                value={formik.values.end_time}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.end_time && formik.errors.end_time && (
                <span className="error-text">{formik.errors.end_time}</span>
              )}
            </div>
          </div>
        </div>
        <div className="pro-d-flex pro-flex-col pro-mb-3 pro-w-100">
          <div className="input-wrap pro-mb-3">
            <div className="pro-d-flex pro-justify-between pro-items-center pro-mb-1">
              <label
                htmlFor="certificate"
                className="pro-font-sm pro-fw-medium"
              >
                Choose Certificate
              </label>
            </div>
            <div className="pro-check-box pro-mb-2">
              <input
                type="checkbox"
                className="pro-check"
                id="select_all_certificate"
                checked={selectAll}
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
              <label
                htmlFor="select_all_certificate"
                className="pro-check-label"
              >
                Select All
              </label>
            </div>
            <AsyncPaginate
              id="certificate"
              name="certificate"
              isMulti
              placeholder={selectAll ? "All Certificates Selected" : "Select"}
              className={`pro-input lg ${
                formik.errors.certificate &&
                formik.touched.certificate &&
                "error"
              }`}
              classNamePrefix="pro-input"
              value={selectAll ? [] : formik.values.certificate}
              loadOptions={loadCertificateOptions}
              onChange={handleCertificateChange}
              onBlur={() => formik.setFieldTouched("certificate", true)}
              menuPlacement="auto"
              isSearchable={!selectAll}
              isDisabled={selectAll}
              additional={{ page: 1 }}
              closeMenuOnSelect={false}
            />
            {formik.touched.certificate && formik.errors.certificate && (
              <span className="error-text">{formik.errors.certificate}</span>
            )}
          </div>
        </div>
        <div className="pro-d-flex pro-flex-col pro-mb-3 pro-w-100">
          <div className="input-wrap pro-mb-3">
            <label
              htmlFor="employee"
              className="pro-font-sm pro-mb-1 pro-fw-medium"
            >
              Choose Employee
            </label>
            <AsyncPaginate
              id="employee"
              name="employee"
              placeholder="Select"
              className={`pro-input lg ${
                formik.errors.employee && formik.touched.employee && "error"
              }`}
              classNamePrefix="pro-input"
              value={formik.values.employee}
              loadOptions={loadEmployeeOptions}
              onChange={(option) => formik.setFieldValue("employee", option)}
              onBlur={() => formik.setFieldTouched("employee", true)}
              menuPlacement="auto"
              isSearchable
              additional={{ page: 1 }}
              getOptionValue={(option) => option.value}
              getOptionLabel={(option) => option.label}
            />
            {formik.touched.employee && formik.errors.employee && (
              <span className="error-text">{formik.errors.employee}</span>
            )}
          </div>
        </div>

        <div className="input-wrap pro-mb-3">
          <label
            htmlFor="remarks"
            className="pro-font-sm pro-mb-1 pro-fw-medium"
          >
            Remarks
          </label>
          <textarea
            id="remarks"
            rows={4}
            name="remarks"
            className={`pro-input lg ${
              formik.errors.remarks && formik.touched.remarks && "error"
            }`}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.remarks}
          ></textarea>
          {formik.touched.remarks && formik.errors.remarks && (
            <span className="error-text">{formik.errors.remarks}</span>
          )}
        </div>
        <div
          className={`col-12 pro-pt-5 pro-d-flex pro-justify-end offcanvas-footer-sticky-btn`}
        >
          <Button className={"pro-btn-link lg pro-px-5"} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className={"pro-btn-primary lg pro-ms-3"}
            type="submit"
            onClick={formik.handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </>
  );
}

export default PhotoUploadWorkModal;
